import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const rsvpApi = createApi({
  reducerPath: 'rsvpApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}/links/v1`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Rsvp'],
  endpoints: (builder) => ({
    getRsvpApi: builder.query({
      query: ({ eventId, link }) => `link/${eventId}?link_id=${link}`,
      providesTags: ['rsvpSearch'],
    }),
  }),
});

export const { useGetRsvpApiQuery, useLazyGetRsvpApiQuery } = rsvpApi;
